<template>
<div>
  <Breadcrumb :home="home" :datas="navDatas" @onNav="handNav" />
  <Item v-if="multiple" :isEndLine="true" :data="{name: '全选'}" :checked="checkAll" @onClick="toggleAll" />
  <!-- <Checkbox v-model="hateVue" />
  <Checkbox :ids.sync="ids" :name="name2" /> -->
  <ListPage :style="{ height: `${scale === 1 ? height/scale : height/(scale-0.12)}px` }" v-loading="loading">
  <Item
    isArrow
    :ids="resultIds"
    v-for="item in treeOrg"
    :key="item.id"
    :data="item"
    :count="count"
    @onClick="handleItem"
    @onDown="handleOrg" />
  <Item
    :ids="resultIds"
    v-for="item in treeAccount"
    :key="item.id"
    :data="item"
    @onClick="handleItem2"
    :isHeadimg="isHeadimg" />
  <!-- <div v-if="!treeOrg.length && !treeAccount.length">空</div> -->
  </ListPage>
</div>
</template>

<script>
import api from './api'
import Breadcrumb from './breadcrumb'
import Item from './item'
import ListPage from './listPage'
import _ from 'lodash'
import { getAllIds, isAll } from './tree'
import mixScale from './mixins/scale'

export default {
  inject: ['multiple'],
  mixins: [mixScale],
  components: {
    Breadcrumb,
    Item,
    ListPage
  },
  props: {
    home: Object,
    isHeadimg: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => []
    },
    count: {
      type: Object,
      default: () => {}
    },
    isAccount: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 254
    },
    shortcutItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      resultIds: [],
      treeOrg: [],
      treeAccount: [],
      navDatas: [],
      currentOrgId: '',
      currentOrgSubjectId: '',
      checkAll: false,
      loading: false
    }
  },
  computed: {

  },
  watch: {
    selectList(list) {
      this.resultIds = getAllIds(list)
      // checkAll
      this.setCheckAll(this.resultIds)
    },
    async currentOrgId(id) {
      await this.getTreeOrg(this.currentOrgSubjectId)
      if (this.isAccount) {
        await this.getAccountByOrgId(id)
      }

      // checkAll
      this.setCheckAll(this.resultIds)

      this.setCount(id)
    }
  },
  mounted() {
    const {
      shortcutItem
    } = this
    if (shortcutItem) {
      this.currentOrgId = shortcutItem.id
      this.navDatas.push(shortcutItem)
    } else {
      this.getTreeOrg('')
    }
  },
  methods: {
    async getOrg(subjectId) {
      try {
        this.loading = true
        const { data } = await api.apiOrgList({
          parentPermissionSubjectId: subjectId
        })
        this.loading = false
        return data
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async getAccountByOrgId(orgId) {
      if (!orgId) {
        this.treeAccount = []
        return true
      }

      try {
        this.loading = true
        const { data } = await api.apiAccountListOrgId({}, null, {
          hasOrg: true,
          orgIdList: orgId
        })
        this.loading = false
        this.treeAccount = data
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async getTreeOrg(id) {
      const data = await this.getOrg(id)
      this.treeOrg = data

      // checkAll
      this.setCheckAll(this.resultIds)
    },
    handNav(item, level) {
      if (level) {
        const {
          id,
          permissionSubjectId
        } = item
        this.navDatas = this.navDatas.slice(0, level)
        this.currentOrgId = id
        this.currentOrgSubjectId = permissionSubjectId
      } else {
        this.navDatas = []
        this.currentOrgId = ''
        this.currentOrgSubjectId = ''
      }
    },
    handleItem(item) {
      this.$emit('onToggle', item)
    },
    handleItem2(item) {
      this.$emit('onToggle', item)
    },
    handleOrg(item) {
      const {
        id,
        permissionSubjectId
      } = item
      this.navDatas.push(item)
      this.currentOrgId = id
      this.currentOrgSubjectId = permissionSubjectId
    },
    toggleAll() {
      this.checkAll = !this.checkAll

      // let allIds = getAllIds([
      //   ...this.treeOrg,
      //   ...this.treeAccount
      // ])
      const allItems = [
        ...this.treeOrg,
        ...this.treeAccount
      ]

      if (this.checkAll) {
        this.count[this.currentOrgId] = allItems.length
      } else {
        this.count[this.currentOrgId] = 0
      }
      this.$emit('onAll', allItems, this.checkAll)
    },
    setCheckAll(ids) {
      const allItems = [
        ...this.treeOrg,
        ...this.treeAccount
      ]

      let allIds = getAllIds(allItems)

      this.checkAll = isAll(ids, allIds)
    },
    setCount(id) {
      const allItems = [
        ...this.treeOrg,
        ...this.treeAccount
      ]

      let allIds = []
      allItems.map(item => {
        allIds.push(item.id)
      })

      const isIds = _.intersection(this.resultIds, allIds)

      if (isIds.length) {
        this.count[id] = isIds.length
      }
    }
  }
}
</script>
